module.exports = __webpack_public_path__ + "img/footer-map.ce9643a.png";